import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import "../css/theme.css";
import "../css/addCreditor.css"; // reuse ac-container/card style

const API_BASE = "https://transactions.arihantauto.in/api";

const DebitorList = () => {
  const [debitors, setDebitors] = useState([]);
  const [filter, setFilter] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editingDebitor, setEditingDebitor] = useState(null);

  useEffect(() => {
    fetchDebitors();
  }, []);

  const fetchDebitors = async (q = "") => {
    try {
      const url = q
        ? `${API_BASE}/get_debitors.php?q=${encodeURIComponent(q)}`
        : `${API_BASE}/debitors.php`;
      const res = await axios.get(url);
      setDebitors(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load debitors");
    }
  };

  const filtered = debitors.filter((d) => {
    const s = filter.toLowerCase();
    return (
      d.name?.toLowerCase().includes(s) ||
      d.code?.toLowerCase().includes(s) ||
      `${d.name} ${d.code}`.toLowerCase().includes(s)
    );
  });

  const exportToExcel = () => {
    if (!filtered.length) {
      alert("No debitors to export.");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(filtered);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Debitors");
    XLSX.writeFile(wb, "Debitors_List.xlsx");
  };

  // const handleDelete = async (code) => {
  //   if (!window.confirm(`Delete debitor ${code}?`)) return;
  //   try {
  //     await axios.delete(`${API_BASE}/debitors.php/${code}`);
  //     setDebitors((prev) => prev.filter((d) => d.code !== code));
  //   } catch (err) {
  //     console.error(err);
  //     alert("Failed to delete");
  //   }
  // };

  const handleEdit = (debitor) => {
    setEditingDebitor({ ...debitor });
    setEditModalVisible(true);
  };

  const handleEditChange = (field, value) => {
    setEditingDebitor((prev) => ({ ...prev, [field]: value }));
  };

  const isTenDigitOrEmpty = (val) =>
    !val || val.trim() === "" || /^\d{10}$/.test(val.trim());

  const validateEditingDebitor = () => {
    const d = editingDebitor;
    if (!d) return false;

    if (!d.name || !d.name.trim()) {
      alert("Name is required.");
      return false;
    }

    if (d.phoneNumber && !/^\d{10}$/.test(d.phoneNumber.trim())) {
      alert("Phone number must be exactly 10 digits.");
      return false;
    }

    if (
      d.paymentInterval !== "" &&
      d.paymentInterval != null &&
      (!Number.isInteger(Number(d.paymentInterval)) ||
        Number(d.paymentInterval) < 0)
    ) {
      alert("Payment Interval must be a non-negative whole number.");
      return false;
    }

    if (
      d.creditDays !== "" &&
      d.creditDays != null &&
      (!Number.isInteger(Number(d.creditDays)) ||
        Number(d.creditDays) < 0)
    ) {
      alert("Credit Days must be a non-negative whole number.");
      return false;
    }

    if (
      d.creditLimit !== "" &&
      d.creditLimit != null &&
      (isNaN(d.creditLimit) || Number(d.creditLimit) < 0)
    ) {
      alert("Credit Limit must be a non-negative number.");
      return false;
    }

    // optional WhatsApps: if filled, must be 10 digits
    if (!isTenDigitOrEmpty(d.whatsapp2)) {
      alert("WhatsApp 2 must be 10 digits if provided.");
      return false;
    }
    if (!isTenDigitOrEmpty(d.whatsapp3)) {
      alert("WhatsApp 3 must be 10 digits if provided.");
      return false;
    }
    if (!isTenDigitOrEmpty(d.whatsapp4)) {
      alert("WhatsApp 4 must be 10 digits if provided.");
      return false;
    }

    return true;
  };

  const saveEdits = async () => {
    if (!editingDebitor) return;
    if (!validateEditingDebitor()) return;

    if (
      !window.confirm(
        `Save changes for debitor ${editingDebitor.code}?`
      )
    )
      return;

    // Normalize numeric fields
    const payload = {
      ...editingDebitor,
      paymentInterval:
        editingDebitor.paymentInterval === "" ||
        editingDebitor.paymentInterval == null
          ? null
          : parseInt(editingDebitor.paymentInterval, 10),
      creditDays:
        editingDebitor.creditDays === "" ||
        editingDebitor.creditDays == null
          ? null
          : parseInt(editingDebitor.creditDays, 10),
      creditLimit:
        editingDebitor.creditLimit === "" ||
        editingDebitor.creditLimit == null
          ? null
          : Number(editingDebitor.creditLimit),
    };

    try {
      await axios.put(`${API_BASE}/debitors.php`, payload);
      setDebitors((prev) =>
        prev.map((d) =>
          d.code === editingDebitor.code ? { ...editingDebitor } : d
        )
      );
      setEditModalVisible(false);
    } catch (err) {
      console.error(err);
      alert("Failed to save changes");
    }
  };

  return (
    <div className="ac-container my-4">
      <h2 className="ac-title">Debitor List</h2>

      <div className="d-flex mb-3" style={{ gap: "0.75rem" }}>
        <input
          type="text"
          className="form-control"
          placeholder="Search by name or code"
          value={filter}
          onChange={(e) => {
            setFilter(e.target.value);
            fetchDebitors(e.target.value);
          }}
        />
        <button className="btn btn-primary fw-semibold" onClick={exportToExcel}>
          Download Excel
        </button>
      </div>

      {filtered.length === 0 ? (
        <p className="text-muted">No debitors found.</p>
      ) : (
        <div className="row g-3">
          {filtered.map((debitor) => (
            <div className="col-12 col-md-6" key={debitor.code}>
              <div className="card border-orange p-3 h-100">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <h5 className="mb-0">
                    {debitor.name} ({debitor.code})
                  </h5>
                  <div>
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => handleEdit(debitor)}
                      type="button"
                    >
                      Edit
                    </button>
                    {/* <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDelete(debitor.code)}
                      type="button"
                    >
                      Delete
                    </button> */}
                  </div>
                </div>

                <div className="mb-2">
                  <p className="mb-1">
                    <strong>Phone:</strong> {debitor.phoneNumber || "-"}
                  </p>
                  <p className="mb-1">
                    <strong>Address:</strong> {debitor.address || "-"}
                  </p>
                </div>

                <div className="mb-2">
                  <p className="mb-1">
                    <strong>Preferred Bank:</strong>{" "}
                    {debitor.preferredBank || "-"}
                  </p>
                  <p className="mb-1">
                    <strong>Payment Interval (days):</strong>{" "}
                    {debitor.paymentInterval ?? "-"}
                  </p>
                  <p className="mb-1">
                    <strong>Credit Days:</strong>{" "}
                    {debitor.creditDays ?? "-"}
                  </p>
                  <p className="mb-1">
                    <strong>Credit Limit:</strong>{" "}
                    {debitor.creditLimit != null
                      ? `₹${debitor.creditLimit}`
                      : "-"}
                  </p>
                  {debitor.notes && (
                    <p className="mb-1">
                      <strong>Notes:</strong> {debitor.notes}
                    </p>
                  )}
                </div>

                <div>
                  <h6 className="text-secondary">Other Contact Persons</h6>
                  {[2, 3, 4].map((i) => {
                    const name = debitor[`contactName${i}`];
                    const desig = debitor[`contactDesignation${i}`];
                    const wa = debitor[`whatsapp${i}`];
                    if (!name && !desig && !wa) return null;
                    return (
                      <div className="border-top pt-2 mt-2" key={i}>
                        <p className="mb-1">
                          <strong>Contact {i}:</strong> {name || "-"}
                        </p>
                        <p className="mb-1">
                          <strong>Designation {i}:</strong>{" "}
                          {desig || "-"}
                        </p>
                        <p className="mb-1">
                          <strong>WhatsApp {i}:</strong>{" "}
                          {wa || "-"}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Edit Modal */}
      <Modal
        show={editModalVisible}
        onHide={() => setEditModalVisible(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Edit Debitor {editingDebitor?.code && `(${editingDebitor.code})`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editingDebitor && (
            <Form>
              <div className="row g-3">
                {/* Primary Details */}
                <div className="col-md-6">
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={editingDebitor.name || ""}
                      onChange={(e) =>
                        handleEditChange("name", e.target.value)
                      }
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group>
                    <Form.Label>Code (read-only)</Form.Label>
                    <Form.Control
                      type="text"
                      value={editingDebitor.code || ""}
                      disabled
                    />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group>
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="text"
                      value={editingDebitor.phoneNumber || ""}
                      onChange={(e) =>
                        handleEditChange("phoneNumber", e.target.value)
                      }
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group>
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="text"
                      value={editingDebitor.address || ""}
                      onChange={(e) =>
                        handleEditChange("address", e.target.value)
                      }
                    />
                  </Form.Group>
                </div>

                {/* Contacts 2–4 */}
                <div className="col-12">
                  <hr />
                  <h5>Other Contacts</h5>
                </div>

                {[2, 3, 4].map((i) => (
                  <React.Fragment key={i}>
                    <div className="col-md-4">
                      <Form.Group>
                        <Form.Label>{`Contact Name ${i}`}</Form.Label>
                        <Form.Control
                          type="text"
                          value={editingDebitor[`contactName${i}`] || ""}
                          onChange={(e) =>
                            handleEditChange(
                              `contactName${i}`,
                              e.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-4">
                      <Form.Group>
                        <Form.Label>{`Designation ${i}`}</Form.Label>
                        <Form.Control
                          type="text"
                          value={
                            editingDebitor[`contactDesignation${i}`] || ""
                          }
                          onChange={(e) =>
                            handleEditChange(
                              `contactDesignation${i}`,
                              e.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-4">
                      <Form.Group>
                        <Form.Label>{`WhatsApp ${i}`}</Form.Label>
                        <Form.Control
                          type="text"
                          value={editingDebitor[`whatsapp${i}`] || ""}
                          onChange={(e) =>
                            handleEditChange(
                              `whatsapp${i}`,
                              e.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </div>
                  </React.Fragment>
                ))}

                {/* Additional Details */}
                <div className="col-12">
                  <hr />
                  <h5>Additional Details</h5>
                </div>

                <div className="col-md-6">
                  <Form.Group>
                    <Form.Label>Preferred Bank</Form.Label>
                    <Form.Control
                      type="text"
                      value={editingDebitor.preferredBank || ""}
                      onChange={(e) =>
                        handleEditChange(
                          "preferredBank",
                          e.target.value
                        )
                      }
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group>
                    <Form.Label>Payment Interval (days)</Form.Label>
                    <Form.Control
                      type="number"
                      value={editingDebitor.paymentInterval ?? ""}
                      onChange={(e) =>
                        handleEditChange(
                          "paymentInterval",
                          e.target.value
                        )
                      }
                    />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group>
                    <Form.Label>Credit Limit</Form.Label>
                    <Form.Control
                      type="number"
                      value={editingDebitor.creditLimit ?? ""}
                      onChange={(e) =>
                        handleEditChange(
                          "creditLimit",
                          e.target.value
                        )
                      }
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group>
                    <Form.Label>Credit Days</Form.Label>
                    <Form.Control
                      type="number"
                      value={editingDebitor.creditDays ?? ""}
                      onChange={(e) =>
                        handleEditChange(
                          "creditDays",
                          e.target.value
                        )
                      }
                    />
                  </Form.Group>
                </div>

                <div className="col-12">
                  <Form.Group>
                    <Form.Label>Notes</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={editingDebitor.notes || ""}
                      onChange={(e) =>
                        handleEditChange("notes", e.target.value)
                      }
                    />
                  </Form.Group>
                </div>
              </div>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setEditModalVisible(false)}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={saveEdits}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DebitorList;